import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, FileText } from "@phosphor-icons/react";
import { BrandMark, Button, Card } from "../components/ui-kit";

const PRIVACY_SECTIONS = [
  {
    title: "Donnees collectees",
    text: "NEXORA-CAB collecte les donnees necessaires au service: nom, telephone, email, role, ville, position GPS pendant une course, informations de paiement non sensibles, historique des courses, notes, incidents SOS et documents chauffeur.",
  },
  {
    title: "Utilisation des donnees",
    text: "Ces donnees servent a creer le compte, calculer les prix, trouver un chauffeur proche, suivre la course, securiser le trajet, gerer les paiements, traiter les reclamations et ameliorer la qualite du service.",
  },
  {
    title: "Localisation",
    text: "La localisation est utilisee pour detecter l'emplacement actuel, proposer un point de depart, suivre le chauffeur et gerer les alertes SOS. Elle n'est pas vendue a des tiers.",
  },
  {
    title: "Partage",
    text: "Les donnees peuvent etre partagees uniquement avec les parties necessaires: chauffeur, client, equipe support, prestataires de paiement, autorites competentes en cas d'obligation legale ou d'incident de securite.",
  },
  {
    title: "Documents et verification",
    text: "Les documents chauffeurs et pieces d'identite peuvent etre analyses par des outils d'assistance IA afin d'aider la verification. La decision finale de validation reste effectuee par l'administration Nexora.",
  },
  {
    title: "Publicites et promotions",
    text: "Nexora peut afficher des promotions et publicites sponsorisees dans l'application. Les annonceurs ne recoivent pas les donnees personnelles des utilisateurs sans consentement ou obligation legale.",
  },
  {
    title: "Conservation et droits",
    text: "Les donnees sont conservees pendant la duree necessaire au service, a la securite et aux obligations comptables. L'utilisateur peut demander l'acces, la correction ou la suppression de ses donnees via le support.",
  },
  {
    title: "Securite",
    text: "Nexora utilise des cookies securises, des journaux d'audit, des sauvegardes et des controles d'acces pour proteger le service. Aucun systeme n'est infaillible; tout incident doit etre signale au support.",
  },
];

const TERMS_SECTIONS = [
  {
    title: "Service",
    text: "NEXORA-CAB met en relation clients et chauffeurs pour des courses urbaines, avec estimation de prix, suivi, notation, historique de paiement et outils de securite.",
  },
  {
    title: "Prix et frais",
    text: "Le prix peut inclure le tarif de la course, une commission plateforme, des frais de service, des frais Mobile Money et des frais d'annulation lorsque les conditions s'appliquent. La politique standard est de 20% pour la plateforme et 80% pour le chauffeur sur les courses terminees.",
  },
  {
    title: "Chauffeurs",
    text: "Les chauffeurs doivent fournir des informations exactes, respecter la securite routiere, maintenir leurs documents a jour et accepter les controles de validation.",
  },
  {
    title: "Paiements",
    text: "Les paiements disponibles actuellement sont cash, M-Pesa, Airtel Money et Orange Money. Le client envoie le montant directement au chauffeur; le chauffeur confirme ensuite la reception dans l'application. Le wallet interne et les paiements carte ne sont pas encore actifs.",
  },
  {
    title: "Annulations, litiges et remboursements",
    text: "Un utilisateur peut ouvrir un ticket support pour signaler un probleme. Nexora peut accepter, refuser ou rembourser selon les preuves disponibles, l'historique de course et les regles operationnelles.",
  },
  {
    title: "Publicites sponsorisees",
    text: "Les entreprises peuvent payer pour des campagnes, affiches, promotions ou notifications. Toute campagne IA reste soumise a l'approbation admin avant publication.",
  },
  {
    title: "Securite et suspension",
    text: "NEXORA-CAB peut suspendre un compte en cas de fraude, abus, comportement dangereux, documents invalides, incident non resolu ou violation de ces conditions.",
  },
  {
    title: "Limitation",
    text: "Nexora facilite la mise en relation et la gestion operationnelle. Les utilisateurs restent responsables des informations fournies, du respect des lois locales et du comportement pendant le trajet.",
  },
];

export default function LegalPage({ type = "privacy" }) {
  const isPrivacy = type === "privacy";
  const sections = isPrivacy ? PRIVACY_SECTIONS : TERMS_SECTIONS;
  const Icon = isPrivacy ? ShieldCheck : FileText;
  const title = isPrivacy ? "Politique de confidentialite" : "Politique d'utilisation";
  const subtitle = isPrivacy
    ? "Comment NEXORA-CAB protege et utilise les donnees."
    : "Regles d'utilisation, frais et responsabilites.";

  return (
    <main className="app-screen bg-premium-grad px-4 pb-5 text-foreground">
      <header className="public-header-safe mx-auto flex max-w-4xl items-center justify-between gap-3">
        <BrandMark className="public-header-brand" />
        <Link to="/">
          <Button variant="outline" className="text-xs">
            <ArrowLeft size={16} weight="bold" />
            Retour
          </Button>
        </Link>
      </header>

      <section className="mx-auto mt-10 max-w-4xl">
        <div className="flex items-center gap-3 text-primary">
          <Icon size={28} weight="duotone" />
          <div className="text-[11px] font-bold uppercase tracking-widest">
            NEXORA-CAB legal
          </div>
        </div>
        <h1 className="mt-3 font-heading text-4xl font-bold leading-tight sm:text-5xl">
          {title}
        </h1>
        <p className="mt-3 max-w-2xl text-sm text-muted-foreground sm:text-base">
          {subtitle} Derniere mise a jour: 3 juin 2026.
        </p>

        <div className="mt-8 grid gap-4">
          {sections.map((section) => (
            <Card key={section.title} className="p-5">
              <h2 className="font-heading text-xl font-bold">{section.title}</h2>
              <p className="mt-2 text-sm leading-6 text-muted-foreground">{section.text}</p>
            </Card>
          ))}
        </div>

        <Card className="mt-6 p-5">
          <h2 className="font-heading text-xl font-bold">Contact</h2>
          <p className="mt-2 text-sm leading-6 text-muted-foreground">
            Pour toute demande: nexora@lillyblessinginvestments.com. Ces textes doivent etre relus par un juriste avant une mise en production commerciale officielle.
          </p>
        </Card>
      </section>
    </main>
  );
}
